export const dataTypes = {
  DATE: 'Date',
  DATE_TIME: 'DateTime',
  INTEGER: 'Integer',
  STRING: 'String',
  DOUBLE: 'Double',
  BIGDECIMAL: 'BigDecimal',
  BOOLEAN: 'Boolean',
  COUNT_OPERATOR: 'Count Operator',
  LONG: 'Long',
};

export const conditionTypeOperators = {
  LESS_THAN: 'LESS_THAN',
  LESS_THAN_OR_EQUALS: 'LESS_THAN_OR_EQUALS',
  GREATER_THAN: 'GREATER_THAN',
  GREATER_THAN_OR_EQUALS: 'GREATER_THAN_OR_EQUALS',
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  EQUALS: 'EQUALS',
  DOES_NOT_EQUAL: 'DOES_NOT_EQUAL',
  MATCH_REG_EX: 'MATCH_REG_EX',
  RANGE: 'RANGE',
  IS_EMPTY: 'IS_EMPTY'
};

export const conditionTypes = [
  {
    type: conditionTypeOperators.LESS_THAN,
    displayName: 'Is Less Than',
    appliesTo: [
      dataTypes.DATE,
      dataTypes.DATE_TIME,
      dataTypes.INTEGER,
      dataTypes.DOUBLE,
      dataTypes.BIGDECIMAL,
      dataTypes.LONG
    ]
  },
  {
    type: conditionTypeOperators.LESS_THAN_OR_EQUALS,
    displayName: 'Is Less Than Or Equals',
    appliesTo: [
      dataTypes.DATE,
      dataTypes.DATE_TIME,
      dataTypes.INTEGER,
      dataTypes.DOUBLE,
      dataTypes.BIGDECIMAL,
      dataTypes.LONG
    ]
  },
  {
    type: conditionTypeOperators.GREATER_THAN,
    displayName: 'Is Greater Than',
    appliesTo: [
      dataTypes.DATE,
      dataTypes.DATE_TIME,
      dataTypes.INTEGER,
      dataTypes.DOUBLE,
      dataTypes.BIGDECIMAL,
      dataTypes.LONG
    ]
  },
  {
    type: conditionTypeOperators.GREATER_THAN_OR_EQUALS,
    displayName: 'Is Greater Than Or Equals',
    appliesTo: [
      dataTypes.DATE,
      dataTypes.DATE_TIME,
      dataTypes.INTEGER,
      dataTypes.DOUBLE,
      dataTypes.BIGDECIMAL,
      dataTypes.LONG
    ]
  },
  {
    type: conditionTypeOperators.CONTAINS,
    displayName: 'Contains',
    appliesTo: [dataTypes.STRING]
  },
  {
    type: conditionTypeOperators.DOES_NOT_CONTAIN,
    displayName: 'Does not Contain',
    appliesTo: [dataTypes.STRING]
  },
  {
    type: conditionTypeOperators.EQUALS,
    displayName: 'Is Equal To',
    appliesTo: [
      dataTypes.DATE,
      dataTypes.STRING,
      dataTypes.INTEGER,
      dataTypes.DATE_TIME,
      dataTypes.DOUBLE,
      dataTypes.BIGDECIMAL,
      dataTypes.BOOLEAN,
      dataTypes.COUNT_OPERATOR,
      dataTypes.LONG
    ]
  },
  {
    type: conditionTypeOperators.DOES_NOT_EQUAL,
    displayName: 'Is Not Equal To',
    appliesTo: [
      dataTypes.DATE,
      dataTypes.STRING,
      dataTypes.INTEGER,
      dataTypes.DATE_TIME,
      dataTypes.DOUBLE,
      dataTypes.BIGDECIMAL,
      dataTypes.BOOLEAN,
      dataTypes.COUNT_OPERATOR,
      dataTypes.LONG
    ]
  },
  {
    type: conditionTypeOperators.RANGE,
    displayName: 'Is Between',
    appliesTo: [
      dataTypes.INTEGER,
      dataTypes.DATE,
      dataTypes.DATE_TIME,
      dataTypes.DOUBLE,
      dataTypes.BIGDECIMAL,
      dataTypes.LONG
    ]
  },
  {
    type: conditionTypeOperators.MATCH_REG_EX,
    displayName: 'Match (REG EX)',
    appliesTo: [dataTypes.STRING]
  },
  {
    type: conditionTypeOperators.IS_EMPTY,
    displayName: 'Is Empty (No Data)',
    appliesTo: [
      dataTypes.DATE,
      dataTypes.STRING,
      dataTypes.INTEGER,
      dataTypes.DATE_TIME,
      dataTypes.DOUBLE,
      dataTypes.BIGDECIMAL,
      dataTypes.BOOLEAN,
      dataTypes.COUNT_OPERATOR,
      dataTypes.LONG
    ]
  }
  // {
  //   type: conditionTypeOperators.IN',
  //   displayName: 'Is in a list',
  //   appliesTo: [dataTypes.STRING, dataTypes.INTEGER, dataTypes.DATE_TIME, dataTypes.DOUBLE]
  // }
];
